import ControlTower from "wise-control-tower";

/**
 * This function will be called by ember-intl when a translation is missing.
 * The message return is the one by default.
 * [ember-intl doc](https://ember-intl.github.io/ember-intl/versions/v6.3.0/docs/guide/missing-translations)
 * @param {string} key
 * @param {string} locales
 * @returns string
 */
export default function missingMessage(key, locales) {
  const message = `Missing translation "${key}" for locales "${locales}"`;
  ControlTower.captureException(new Error(`[ember-intl] ${message}`));
  return message;
}
